import { Head } from "@landrr/core";
import { pages } from "../site.config";
import { BlockRenderer } from "./BlockRenderer";

interface HomeProps {
  serverData?: Record<string, unknown>;
}

export const ssr = { mode: "ssg" as const };

export async function getServerData() {
  return {
    renderedAt: new Date().toISOString(),
  };
}

export default function Home({ serverData }: HomeProps) {
  return (
    <>
      <Head
        title="Landrr.js — Fast, SEO-ready React framework"
        description="A modern React framework for fast client sites. TypeScript, Vite, SSR, SSG, and React 18."
        ogTitle="Landrr.js"
        ogDescription="Build landing pages, docs, and client sites with Vite, SSR, SSG, and React 18."
        ogType="website"
        twitterCard="summary_large_image"
      />
      <div className="min-h-screen flex flex-col">
        <main className="flex-1">
          <BlockRenderer entries={pages.home} />
        </main>
        <p className="sr-only">
          SSR timestamp: {(serverData?.renderedAt as string | undefined) ?? "n/a"}
        </p>
      </div>
    </>
  );
}
